export default __webpack_public_path__ + "static/assets/24d55c2bdbfda43cd74f48ebe471d971.png";